import Navbar from '../navbar/Navbar'
import Card from './Card'
import { BsPlusLg } from 'react-icons/bs'
import { MdClose } from 'react-icons/md'
import { useContext, useEffect, useRef, useState } from 'react';
import Sidebar from '../sidebar/Sidebar';
import { toast, ToastContainer } from 'react-toastify';
import { addDoc, collection, deleteDoc, doc, getDocs, onSnapshot, orderBy, query, where } from 'firebase/firestore';
import { db } from '../../firebase';
import { Wave } from 'better-react-spinkit';
import { FaRegFileAlt, FaRobot } from 'react-icons/fa';
import { AuthContext } from '../../authContext/AuthContext';
import jsPDF from 'jspdf';
import Papa from "papaparse";

const Jobs = () => {
    const [genrateTable, setGenrateTable] = useState(false)
    const { currentUser } = useContext(AuthContext)
    const [showModal, setShowModal] = useState(false);
    const [jobType, setJobType] = useState('Plotter')
    const [stiches, setStiches] = useState('')
    const [jobs, setJobs] = useState([]);
    const [droppedJob, setDroppedJob] = useState({})
    const [isLoading, setIsLoading] = useState(false)
    const [jobTypeChange, setJobTypeChange] = useState('Plotter')
    const [filename, setFilename] = useState('')
    const inputRef = useRef(null);


    useEffect(() => {
        const get_Jobs = async () => {
            setIsLoading(true)
            const q = query(collection(db, "jobs"), where('adminId', '==', currentUser.uid), where('jobType', '==', jobTypeChange), orderBy('createdAt', 'asc'));

            onSnapshot(q, (querySnapshot) => {
                const data = []
                querySnapshot.forEach((doc) => {
                    data.push({
                        ...doc.data(),
                        id: doc.id
                    })
                });
                setJobs(data)
                setIsLoading(false)
            })
        }
        get_Jobs()
    }, [currentUser.uid, jobTypeChange])

    const handleAddJob = async (e) => {
        e.preventDefault()
        setIsLoading(true)
        const form = e.target
        if (form.checkValidity()) {
            const formData = new FormData(form)
            const formValues = Array.from(formData.keys()).reduce((acc, key) => {
                acc[key] = form.elements[key].value
                return acc
            }, {})
            const query_job = query(collection(db, "jobs"), where('fileName', '==', formValues.fileName))
            const snapshot_job = await getDocs(query_job)
            if (snapshot_job.empty) {
                let new_Job = {
                    ...formValues,
                    forwork: parseInt(formValues.forwork),
                    totalPieces: parseInt(formValues.totalPieces),
                    createdAt: Date.now(),
                    adminId: currentUser.uid,
                    workinprogressby: [],
                    bad: 0,
                    productedPieces: 0,
                    machineId: '',
                    round: 0,
                    completedAt: ''
                }
                if (jobType === 'Embroidery') {
                    if (stiches === '') {
                        toast.error('Please select file.')
                        setIsLoading(false)
                        return
                    }
                    new_Job = {
                        ...new_Job,
                        stiches
                    }
                    setStiches('')
                }
                await addDoc(collection(db, "jobs"), new_Job)

                toast.success("New Job has been successfully added.")
                form.reset()
                setJobType('Plotter')
                setFilename('')

            } else {
                toast.error('This filename is already taken!')
            }
            setIsLoading(false)
        } else {
            const formData = new FormData(form)
            const validationMessages = Array.from(formData.keys()).reduce((acc, key) => {
                acc[key] = form.elements[key].validationMessage
                return acc
            }, {})
            setIsLoading(false)
            if (jobType === 'Embroidery') {
                toast.error(
                    validationMessages.fileName !== '' ?
                        'Name: ' + validationMessages.fileName :
                        validationMessages.totalPieces !== '' ?
                            'Total Pieces: ' + validationMessages.totalPieces :
                            validationMessages.delivery !== '' ?
                                'Delivery Date: ' + validationMessages.delivery : null

                )

            } else if (jobType === 'Plotter') {
                toast.error(
                    validationMessages.name !== '' ?
                        'Name: ' + validationMessages.name :
                        validationMessages.fileName !== '' ?
                            'File Name: ' + validationMessages.fileName :
                            validationMessages.forwork !== '' ?
                                'For Work: ' + validationMessages.forwork :
                                validationMessages.totalPieces !== '' ?
                                    'Total Pieces: ' + validationMessages.totalPieces : validationMessages.delivery !== '' ?
                                        'Delivery Date: ' + validationMessages.delivery : null
                )
            }
        }
    }


    async function dropJob(id) {
        await deleteDoc(doc(db, 'jobs', id))
        setJobs(pre => pre.filter(p => p.id !== id))
        setDroppedJob({})
    }


    const handleTypeChange = (e) => {
        setJobTypeChange(e.target.value)
    }

    const handlePDF = () => {
        setGenrateTable(prev => !prev)
        setTimeout(() => {
            const doc = new jsPDF('p', 'pt', 'a3');
            doc.html(inputRef?.current.innerHTML, {
                callback: (pdf) => {
                    pdf.save('myPdf.pdf')
                    setGenrateTable(prev => !prev)
                }
            })
        }, 300);
    }

    const handleFileChange = (e) => {
        var file = e.target.files[0];

        function renameFile(originalFile, newName) {
            setFilename(originalFile.name.split('.')[0])
            return new File([originalFile], newName, {
                type: originalFile.type,
                lastModified: originalFile.lastModified,
            });
        }

        const newfile = renameFile(file, 'name.csv')

        const reader = new FileReader();

        reader.onload = async ({ target }) => {
            const csv = Papa.parse(target.result, { header: true });
            const parsedData = csv?.data;
            setStiches(Object.values(parsedData[0])[0].split("ST:  ")[1].trim())
        };
        reader.readAsText(newfile)
    }

    return (
        <div className='bg-gray-100'>
            <Navbar />
            <div className="flex">
                <Sidebar currentPage='Jobs' />
                <div className="flex-1 bg-gray-100 overflow-hidden h-[calc(100vh-50px)] flex justify-center items-center">
                    <div className="w-[98%] mx-2 shadow bg-white rounded-lg h-[96%] flex flex-col overflow-hidden">
                        <header className="w-full h-16 bg-gray-50 shadow flex justify-between items-center px-2 sm:px-3">
                            <h1 className='font-bold text-xl box-border text-slate-600'>Jobs</h1>
                            <div className="flex space-x-2 sm:space-x-3 items-center">
                                <button className='flex justify-center btn-color shadow text-white py-1 items-center px-3 font-medium rounded-md cursor-pointer' onClick={handlePDF}>Genrate PDF</button>
                                <div>
                                    <select onChange={handleTypeChange} className=' shadow text-[14px] bg-white px-1 sm:px-3 py-2 rounded-lg text-slate-800 outline-none'>
                                        <option value="Plotter">Plotter</option>
                                        <option value="Embroidery">Embroidery</option>
                                    </select>
                                </div>
                                <div onClick={() => setShowModal(!showModal)} className="flex h-8 sm:h-auto justify-center btn-color shadow text-white py-1 items-center px-3 font-medium rounded-md cursor-pointer">
                                    <BsPlusLg className='text-white font-bold text-sm sm:mr-2' />
                                    <span className='hidden sm:block'>
                                        Add Job
                                    </span>
                                </div>
                            </div>
                        </header>
                        <div className="flex-1 overflow-auto">
                            <div className="flex flex-1 p-1 flex-wrap justify-center">
                                {jobs.sort((j1, j2) => j2.createdAt - j1.createdAt).map((job, index) => (
                                    <Card key={job.id + index} job={job} index={index} setDroppedJob={setDroppedJob} />
                                ))}
                                {isLoading && <div className='flex items-center w-full h-[70vh] justify-center'><Wave color='gray' size={50} /></div>}
                                {!isLoading && jobs.length === 0 && <p className='bg-slate-200 p-2 mt-2 text-slate-600 flex items-center text-lg font-semibold w-full h-[70vh] justify-center'><FaRobot className='mr-2 text-2xl' /> Nothing to show.</p>}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {showModal ? (
                <>
                    <div
                        className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none"
                    >
                        <div className="relative w-auto my-6 mx-auto max-w-3xl">
                            <div className="border-0 rounded-lg shadow-lg relative flex flex-col max-h-[85vh] w-[100vw] sm:w-[360px] bg-white outline-none focus:outline-none">
                                {/*header*/}
                                <div className="flex items-center justify-between px-3 py-4 border-b border-solid border-slate-200 rounded-t">
                                    <h3 className="text-xl font-semibold">
                                        Add Job
                                    </h3>
                                    <MdClose className='text-2xl cursor-pointer font-bold text-black' onClick={() => setShowModal(false)} />
                                </div>
                                {/*body*/}
                                <form onSubmit={handleAddJob} onReset={() => setJobType('Plotter')} noValidate className="relative p-3 sm:p-2 flex-auto flex flex-col overflow-auto h-full">
                                    <div>
                                        <select name='jobType' onChange={(e) => { setJobType(e.target.value); setFilename('') }} className='border border-gray-400 outline-none shadow my-2 w-full bg-gray-100 h-12 px-3 rounded-lg text-slate-800'>
                                            <option value="Plotter">Plotter</option>
                                            <option value="Embroidery">Embroidery</option>
                                        </select>
                                        {jobType === "Embroidery" ? (
                                            <>
                                                <div className="relative flex border border-gray-400 outline-none shadow my-2 w-full bg-gray-100 h-12 px-3 rounded-lg text-slate-800">
                                                    <label htmlFor="DSTFILE" className='flex items-center w-full'><FaRegFileAlt className='text-xl mr-2' />Open File</label>
                                                    <input name='stiches' id='DSTFILE' hidden type='file' onChange={handleFileChange} />
                                                    {stiches !== '' && <span className='absolute top-[15%] right-1 shadow-md text-gray-50 font-semibold px-3 py-1 bg-purple-700 rounded-2xl flex items-center justify-center'>{stiches}</span>}
                                                </div>
                                            </>
                                        ) : jobType === "Plotter" && (
                                            <>
                                                <input name="forwork" required minLength='1' type="number" className='border border-gray-400 outline-none shadow my-2 w-full bg-gray-100 h-12 px-3 rounded-lg text-slate-800' placeholder='Pieces For Work' />
                                            </>
                                        )}
                                        <input name="name" required minLength='3' type="text" className='border border-gray-400 outline-none shadow my-2 w-full bg-gray-100 h-12 px-3 rounded-lg text-slate-800' placeholder='Name' />
                                        <input name="fileName" onChange={(e) => setFilename(e.target.value)} required minLength='2' value={filename} type="text" className='border border-gray-400 outline-none shadow my-2 w-full bg-gray-100 h-12 px-3 rounded-lg text-slate-800' placeholder={jobType==='Embroidery' ? 'Job Order Name' : 'File Name'} />
                                        <input name="totalPieces" required type="number" className='border border-gray-400 outline-none shadow my-2 w-full bg-gray-100 h-12 px-3 rounded-lg text-slate-800' placeholder='Total pieces' />
                                        <input name="delivery" required type="date" className='border border-gray-400 outline-none shadow my-2 w-full bg-gray-100 h-12 px-3 rounded-lg text-slate-800' placeholder='Delivery Date' />
                                    </div>
                                    <button
                                        disabled={isLoading}
                                        className="bg-emerald-500 mt-3 flex items-center justify-center disabled:bg-gray-400 text-white active:bg-emerald-600 font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                                        type="submit"
                                    >
                                        {isLoading ? <Wave size={32} color='white' />
                                            : 'Submit'}
                                    </button>
                                </form>
                                {/*footer*/}
                                <div style={{ boxShadow: '0 0 7px rgba(0,0,0,0.35)' }} className="z-50 flex items-center justify-end p-2 border-t border-solid border-slate-200 rounded-b">
                                    <button
                                        className="text-red-500 bg-gray-200 rounded-lg background-transparent font-bold uppercase px-6 py-2 text-sm outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                                        type="button"
                                        onClick={() => setShowModal(false)}
                                    >
                                        Close
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
                </>
            ) : null}

            {Object.keys(droppedJob).length !== 0 ? (
                <>
                    <div
                        className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none"
                    >
                        <div className="relative w-auto my-6 mx-auto max-w-3xl">
                            <div className="border-0 rounded-lg shadow-lg relative flex flex-col max-h-[84vh] w-[100vw] sm:w-[360px] bg-white outline-none focus:outline-none">
                                {/*header*/}
                                <div className="flex items-center justify-between px-3 py-3 border-b border-solid border-slate-200 rounded-t">
                                    <h5 className="text-xl font-semibold">
                                        Are you sure you want to delete?
                                    </h5>
                                    <MdClose className='text-2xl cursor-pointer font-bold text-black' onClick={() => { setDroppedJob({}) }} />
                                </div>
                                {/*body*/}

                                {/*footer*/}
                                <div className="flex items-center justify-end p-2 border-t border-solid border-slate-200 rounded-b">
                                    <button
                                        className="bg-blue-500 flex items-center justify-center disabled:bg-gray-400 text-white active:bg-blue-600 font-bold uppercase text-sm px-6 py-2 rounded-lg shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                                        type="button"
                                        onClick={() => {
                                            dropJob(droppedJob.id)
                                            setDroppedJob({})
                                        }}
                                    >
                                        Yes
                                    </button>
                                    <button
                                        className="modal-close-btn"
                                        type="button"
                                        onClick={() => { setDroppedJob({}) }}
                                    >
                                        No
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
                </>
            ) : null}


            <ToastContainer
                position="top-right"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme='dark'
            />

            {genrateTable && <div ref={inputRef} className='hidden'>
                <h1 className='ml-5 mt-3'>Jobs</h1>
                <table className='border-[1px] borer-slate-500 m-5 w-[800px]'>
                    <thead className='bg-gray-100'>
                        <tr>
                            <th className='border-[1px] borer-slate-500 p-2 text-[9px] text-left'>Sr.no</th>
                            <th className='border-[1px] borer-slate-500 p-2 text-[9px] text-left'>Type</th>
                            <th className='border-[1px] borer-slate-500 p-2 text-[9px] text-left'>Name</th>
                            <th className='border-[1px] borer-slate-500 p-2 text-[9px] text-left'>Filename</th>
                            <th className='border-[1px] borer-slate-500 p-2 text-[9px] text-left'>Stiches</th>
                            <th className='border-[1px] borer-slate-500 p-2 text-[9px] text-left'>In progress by</th>
                            <th className='border-[1px] borer-slate-500 p-2 text-[9px] text-left'>Total pieces</th>
                            <th className='border-[1px] borer-slate-500 p-2 text-[9px] text-left'>Bad</th>
                            <th className='border-[1px] borer-slate-500 p-2 text-[9px] text-left'>P.Pieces</th>
                            <th className='border-[1px] borer-slate-500 p-2 text-[9px] text-left'>Delivery</th>
                            <th className='border-[1px] borer-slate-500 p-2 text-[9px] text-left'>Task Status</th>
                        </tr>
                    </thead>
                    <tbody>
                        {jobs.map((j, i) => (
                            <tr key={i}>
                                <td className='border-[1px] borer-slate-500 p-2 text-[9px]'>{i + 1}</td>
                                <td className='border-[1px] borer-slate-500 p-2 text-[9px]'>{j.jobType}</td>
                                <td className='border-[1px] borer-slate-500 p-2 text-[9px]'>{j.name}</td>
                                <td className='border-[1px] borer-slate-500 p-2 text-[9px]'>{j.fileName}</td>
                                <td className='border-[1px] borer-slate-500 p-2 text-[9px]'>{j.stiches}</td>
                                <td className='border-[1px] borer-slate-500 p-2 text-[9px]'>{j.workinprogressby?.map((e, i) => j.workinprogressby.length === 1 ? e.name : i + 1 === j.workinprogressby.length ? e.name : e.name + ', ')}</td>
                                <td className='border-[1px] borer-slate-500 p-2 text-[9px]'>{j.totalPieces}</td>
                                <td className='border-[1px] borer-slate-500 p-2 text-[9px]'>{j.bad}</td>
                                <td className='border-[1px] borer-slate-500 p-2 text-[9px]'>{j.productedPieces}</td>
                                <td className='border-[1px] borer-slate-500 p-2 text-[9px]'>{j.delivery}</td>
                                <td className='border-[1px] borer-slate-500 p-2 text-[9px]'>{j.taskStatus}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>}
        </div>
    )
}

export default Jobs
